import Component from '../core/Component'
import { queryAll } from '../utils/dom'
import EventBus from '../core/EventBus'

export default class LoadingImages extends Component {

    prepare() {
        const images = queryAll('img', this.element)

        Promise.all(images.map(element => {
            return new Promise((resolve, reject) => {
                const image = new Image()
                image.onload = () => resolve()
                image.onerror = () => resolve()
                image.src = element.src
            })
        }))
            .then(() => {
                EventBus.emit('contentchange')
            })
    }

}